<div class="language-selector">
  <form [formGroup]="formGroup">
    <mat-form-field subscriptSizing="dynamic">
      <mat-select formControlName="language" #select="matSelect">
        <mat-select-trigger>
          <!--<img [attr.src]="getFlag(select.selected?.value) | safe: 'resourceUrl'" class="flag">-->
          <span>{{ select.selected?.viewValue }}</span>
        </mat-select-trigger>
        <mat-option value="" disabled selected>{{ 'languages.selectLanguage' | translate }}</mat-option>
        <mat-option *ngFor="let language of availableLanguages" [value]="language.code">
          <!--<img [attr.src]="language.flag | safe: 'resourceUrl'" class="flag">-->
          <span *ngIf="language.i18nKey">{{ language.i18nKey | translate }}</span>
          <span *ngIf="!language.i18nKey">{{ language.text | translate }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
